import { inject } from 'vue';
import {
  type OrganizationPageContext,
  organizationPageKey
} from './useOrganizationContext';

export function useOrganizationPageData(): OrganizationPageContext {
  const context = inject(organizationPageKey);
  if (!context) {
    throw new Error(
      'useOrganizationPageData must be used within OrganizationCreateProvider'
    );
  }
  return context;
}
